import { useEffect } from "react";
import usePlacesAutocomplete from "use-places-autocomplete";
import { onGooglePlacesReady } from "utils/scriptLoader";

export default function useReadyPlacesAutocomplete(
  options: Parameters<typeof usePlacesAutocomplete>[0],
) {
  const autocomplete = usePlacesAutocomplete({ ...options, initOnMount: false });
  const { init } = autocomplete;

  useEffect(() => onGooglePlacesReady(init), [init]);

  return autocomplete;
}
